import { buttonRecipe } from "./button.recipe";
import { inputRecipe } from "./input.recipe";
import { headingRecipe } from "./heading.recipe";
import { textRecipe } from "./text.recipe";
import { linkRecipe } from "./link.recipe";

export const recipes = {
  button: buttonRecipe,
  input: inputRecipe,
  heading: headingRecipe,
  text: textRecipe,
  link: linkRecipe,
};
